/**
 * useCredentials Application Hook
 */

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useCredentials() {
  const name = useSelector((state) => state.AuthReducer.userData
    ? `${state.AuthReducer.userData.firstName} ${state.AuthReducer.userData.lastName}`
    : undefined);
  const userId = useSelector((state) => state.AuthReducer.userId);
  const token = useSelector((state) => state.AuthReducer.token);
  const whatsapp = useSelector((state) => state.AuthReducer.userData?.whatsapp);
  
  const isLogged = useMemo(() => token && userId, [token, userId]);

  /*  const login = ({ email, password }) => apiService(true)
    .Credential.createCredential({ email, password })
    .then(() => {

    });

  const logout = () => mutations.destructCredentials.mutate(); */

  return {
    commands: {
      // login,
      // logout,
    },
    sharedStates: {
      isLogged,
      name,
      token,
      userId,
      whatsapp,
    },
  };
}
